<template>
	<div class="full" style="background-color: white;">
		<el-container class="full">
			<el-aside width="250px" style="border-right: 1px solid #DCDFE6;">
				<emun-tree :field="name" ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-aside>
			<el-container class="full flex"
				style="position: relative;flex-direction: column;box-sizing: border-box;padding: 20px;">
				<el-header class="bread" style="position: relative;height: 30px;">
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="parentbread.length!=0">
						<el-breadcrumb-item v-for="(item,index) in parentbread" :key="index">{{item.name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<div v-else></div>
				</el-header>
				<el-main>
					<el-divider content-position="left">关系映射</el-divider>
					<el-form ref="form" :model="form" label-width="120px" v-loading="loading"
						style="flex: 1;position: relative;" v-if="currentitem && currentitem.children.length==0"
						element-loading-background="rgba(255, 255, 255, 0.5)">
						<el-form-item label="万里牛售后原因" style="width: 600px;">
							<el-select size="mini" v-model="form.wln_reason" filterable @change="reasonChange">
								<el-option :key="item.reasonID" v-for="item in reasonoptions" :label="item.name"
									:value="item.name"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="万里牛售后原因ID" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasonid"></el-input>
						</el-form-item>
						<el-form-item label="售后类型" style="width: 600px;">
							<el-select size="mini" v-model="form.type" clearable>
								<el-option label="补发" :value="1"></el-option>
								<el-option label="仅退款" :value="4"></el-option>
								<el-option label="退货" :value="0"></el-option>
								<el-option label="换货" :value="2"></el-option>
								<el-option label="维修" :value="5"></el-option>
								<el-option label="其他" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="问题描述【补发】" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasondetail_bufa"></el-input>
						</el-form-item>
						<el-form-item label="问题描述【仅退款】" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasondetail_jintuikuan"></el-input>
						</el-form-item>
						<el-form-item label="问题描述【退货】" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasondetail_tuihuo"></el-input>
						</el-form-item>
						<el-form-item label="问题描述【换货】" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasondetail_huanhuo"></el-input>
						</el-form-item>
						<el-form-item label="问题描述【其他】" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasondetail_qita"></el-input>
						</el-form-item>
						<el-form-item label="问题描述【维修】" style="width: 600px;">
							<el-input size="mini" v-model="form.wln_reasondetail_weixiu"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button style="float: right;" type="success" @click="onSubmit" size="mini">保存</el-button>
						</el-form-item>
					</el-form>
				</el-main>
			</el-container>
		</el-container>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	export default {
		name: 'emunextend_tasktypeIndex',
		props: {
			name: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading: false,
				currentitem: null,
				emunid: 0,
				emuntTreeKey: Math.random(),
				parentbread: [],
				tableData: [],
				form: {
					type: null,
					wln_reason: null,
					wln_reasonid: null,
					wln_reasondetail_bufa: null,
					wln_reasondetail_jintuikuan: null,
					wln_reasondetail_tuihuo: null,
					wln_reasondetail_huanhuo: null,
					wln_reasondetail_qita: null,
					wln_reasondetail_weixiu: null
				},
				reasonoptions: []
			}
		},
		watch: {
			emunid() {
				this.get()
			}
		},
		created() {
			let field = []
			for (let i in this.attr) {
				field.push(i)
			}
			if (field.length != 0) {
				this.$api.emunlist.list({
					field: field.join(',')
				}).then((res) => {
					res.forEach((item) => {
						this.attr[item.field].push(item)
					})
				})
			}
		},
		mounted() {
			this.getwlnreason()
		},
		computed: {

		},

		methods: {
			getwlnreason() {
				this.$api.emunextend_exchangeorderreason.getwlnreason().then((item) => {
					this.reasonoptions = item.map((item) => {
						return {
							name: item.name,
							id: item.reasonID,
						}
					})
				})
			},
			reasonChange(e) {
				console.log(e)
				let target = this.reasonoptions.find((item) => {
					return item.name == e
				})
				if (target) {
					this.form.wln_reasonid = target.id
				}
			},
			get() {
				if (!this.emunid) {
					this.$message.error('请选择商品')
					return
				}
				this.loading = true
				this.$api.emunextend_exchangeorderreason.get(this.emunid).then((res) => {
					this.loading = false
					if (res) {
						this.form.type = res.type
						this.form.wln_reason = res.wln_reason
						this.form.wln_reasonid = res.wln_reasonid
						this.form.wln_reasondetail_bufa = res.wln_reasondetail_bufa
						this.form.wln_reasondetail_jintuikuan = res.wln_reasondetail_jintuikuan
						this.form.wln_reasondetail_huanhuo = res.wln_reasondetail_huanhuo
						this.form.wln_reasondetail_qita = res.wln_reasondetail_qita
						this.form.wln_reasondetail_tuihuo = res.wln_reasondetail_tuihuo
						this.form.wln_reasondetail_weixiu = res.wln_reasondetail_weixiu
					} else {
						this.form.type = null
						this.form.wln_reason = null
						this.form.wln_reasonid = null
						this.form.wln_reasondetail_bufa = null
						this.form.wln_reasondetail_jintuikuan = null
						this.form.wln_reasondetail_huanhuo = null
						this.form.wln_reasondetail_qita = null
						this.form.wln_reasondetail_tuihuo = null
						this.form.wln_reasondetail_weixiu = null
					}

				})
			},
			onSubmit() {
				if (!this.emunid) {
					this.$message.error('请选类型')
					return
				}
				this.$api.emunextend_exchangeorderreason.save({
					emunvalueid: this.emunid,
					type: this.form.type,
					wln_reason: this.form.wln_reason,
					wln_reasonid: this.form.wln_reasonid,
					wln_reasondetail_bufa: this.form.wln_reasondetail_bufa,
					wln_reasondetail_jintuikuan: this.form.wln_reasondetail_jintuikuan,
					wln_reasondetail_huanhuo: this.form.wln_reasondetail_huanhuo,
					wln_reasondetail_qita: this.form.wln_reasondetail_qita,
					wln_reasondetail_tuihuo: this.form.wln_reasondetail_tuihuo,
					wln_reasondetail_weixiu: this.form.wln_reasondetail_weixiu
				}).then(() => {
					this.$message.success('操作成功')
				})

			},
			emuntTreeChange(e) {
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
		},
		components: {
			emunTree,

		}
	}
</script>